import { render } from "./SignageListAssignmentModal.vue?vue&type=template&id=c83fb214&scoped=true&ts=true"
import script from "./SignageListAssignmentModal.vue?vue&type=script&lang=ts"
export * from "./SignageListAssignmentModal.vue?vue&type=script&lang=ts"

import "./SignageListAssignmentModal.vue?vue&type=style&index=0&id=c83fb214&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83fb214"]])

export default __exports__